<template>
	<div :class="['sub-values', { 'inline': !data.yesNo }]">
		<div v-if="!data.yesNo" class="sub-value">
			<div class="label">{{ data.yesNo === null ? 'Egal' : 'Nein' }}</div>
		</div>
		<template v-else>
			<div class="sub-value">
				<div class="label">Umfang</div>
				<div>
					<Label :characteristic="data.scope" :label-type="labelTypeApplication" />
				</div>
			</div>
			<div class="sub-value">
				<div class="label">Externe Übernachtungen</div>
				<div>
					<template v-if="!data.externalSleepoverYesNo">
						{{ data.externalSleepoverYesNo === null ? 'Egal' : 'Nein' }}
					</template>
					<Label
						v-else
						:characteristic="data.externalSleepoverScope"
						:label-type="labelTypeApplication"
					/>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import SelectedItems from "@/vue/characteristic/SelectedItems.vue";
import {mapState} from "vuex";
import Label from "@/vue/characteristic/Label.vue";
import {APPLICATION} from "@/helper/characteristic/Label";

export default {
	components: {Label, SelectedItems},

	props: {
		data: {
			type: Object,
			required: true,
		},
	},

	computed: {
		...mapState('meta', ['meta']),
		labelTypeApplication ()
		{
			return APPLICATION;
		}
	}
}
</script>
